// tslint:disable-next-line:class-name
export class userProfile {
  public Phone: string;
  public Fax: string;
  public Email: string;
  public OldPhone: string;
  public OldFax: string;
  public OldEmail: string;
  public OptoutType: string;
  public OptoutComments: string;
  public OldOptoutType: string;
  public OldOptoutComments: string;
  public bearerToken: string;
  public id: string;
}



// WEBPACK FOOTER //
// ./src/app/models/userProfile.ts